
















import { bemBuilder } from "@/v2/util/bem-builder";
import { defineComponent } from "@vue/composition-api";
import { t } from "@/i18n";
import {
  AtomText,
  AtomTextTypeEnum,
  AtomTextColorEnum,
} from "@/v2/new-design-system";

const css = bemBuilder("campaign-whatsapp-list");

export default defineComponent({
  name: "CampaignWhatsAppList",
  components: { AtomText },
  props: {
    businessId: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      t,
      css,
      AtomTextTypeEnum,
      AtomTextColorEnum,
    };
  },
});
